import React, { forwardRef, useEffect } from "react";
import {
  makeStyles,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { useQuery } from "@apollo/client";
import { useState } from "react";

import styled from "styled-components";

import sanitizeHtml from "sanitize-html";
import Moment from "react-moment";
import { GET_NOTICE_BY_ID } from "../../../../quries/notice";
import "./editor.css";
import BoardViewFileList from "./BoardViewFileList";
import MetaSeo from "../../../MetaSeo";

const useStyles = makeStyles((theme) => ({
  topContainer: {
    paddingTop: "10rem",
    paddingBottom: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "5rem",
      paddingBottom: "6rem",
    },
  },
  viewContainer: {
    marginBottom: 32,
    paddingTop: 16,
    paddingBottom: 16,
    borderTop: "1px solid #CCC",
    borderBottom: "1px solid #CCC",
    [theme.breakpoints.down("xs")]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  titleZone: {
    fontWeight: 900,
    [theme.breakpoints.down("xs")]: {
      fontWeight: 700,
      fontSize: 16,
      paddingTop: 16,
      paddingBottom: 8,
      // borderBottom: "1px solid #CCC",
    },
  },

  dateZone: {
    fontWeight: 300,
    textAlign: "right",
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
      paddingBottom:16
    },
  },
}));

interface BoardViewProps {
  //   children: React.ReactNode | null | string | undefined;
  match: any;
  history: any;
}

function BoardView({ match, history }: BoardViewProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const [title, setTitle] = useState<any>(null);
  const [describe, setDescribe] = useState<any>(null);
  const [date, setDate] = useState<any>(null);
  const [noticeFile, setNoticeFile] = useState<any>(null);
  const defaultOptions = {
    allowedTags: [
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "main",
      "ol",
      "p",
      "pre",
      "ul",
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr",
      "img",
      "oembed",
    ],
    allowedClasses: {
      p: ["fancy", "simple", "media"],
      figure: ["image", "media"],
    },
    allowedAttributes: {
      h1: ["class"],
      h2: ["class"],
      h3: ["class"],
      h5: ["class"],
      h6: ["class"],
      span: ["style"],
      p: ["style"],
      a: ["href", "name", "target"],
      figure: ["class"],
      mark: ["class"],
      img: ["src", "class"],
      li: ["class"],
      oembed: ["url", "class"],
      // img: ["img"],
    },
    allowedSchemes: ["http", "https", "ftp", "mailto"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowedIframeHostnames: ["www.youtube.com"],
  };

  const sanitize = (dirty: any, options: any) => ({
    __html: sanitizeHtml(
      dirty,
      { ...defaultOptions, ...options }
      // options: { ...defaultOptions, ...options }
    ),
  });

  const SanitizeHTML = ({ html, options }: any) => (
    <div dangerouslySetInnerHTML={sanitize(html, options)} />
  );

  const { data, loading, error } = useQuery(GET_NOTICE_BY_ID, {
    variables: {
      id: match.params.notice_id,
    },
  });
  useEffect(() => {
    if (data && data.notice) {
      let notice = data.notice;

      setTitle(notice.title);
      setDescribe(notice.description);
      setDate(notice.created_at);
      setNoticeFile(notice.notice_file);
    }
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.notice) {
    console.log(error);
  }

  return (
    <Container className={classes.topContainer}>
      <MetaSeo
        data={{
          title: title,
          description: describe,
          canonical: `http://laborbusan.or.kr/notice/view/${match.params.notice_id}`,
        }}
      />
      <Grid xs={12} item>
        <Grid
          xs={12}
          item
          container
          className={classes.viewContainer}
          justify={"center"}
        >
          <Grid xs={!matches ? 10 : 12} item>
            <h5 className={classes.titleZone}>{title}</h5>
          </Grid>
          <Grid xs={!matches ? 2 : 12} item>
            <h6 className={classes.dateZone}>
              <Moment format="YYYY년 MMM Do ">{date}</Moment>
            </h6>
          </Grid>
        </Grid>
        <Grid
          xs={12}
          item
          style={{ borderBottom: "1px solid #CCC", paddingBottom: 32 }}
          id={"labor-editor-view"}
        >
          <SanitizeHTML html={`${describe}`} />
        </Grid>
      </Grid>
      <BoardViewFileList fileArray={noticeFile} />
    </Container>
  );
}

export default BoardView;
